import React, { useEffect } from 'react';
import { LandingNavbar } from '../landing/LandingNavbar';
import { LandingFooter } from '../landing/LandingFooter';

interface ContentLayoutProps {
    children: React.ReactNode;
    title: string;
    description: string;
    onGetStarted: () => void;
}

export const ContentLayout: React.FC<ContentLayoutProps> = ({ children, title, description, onGetStarted }) => {
    useEffect(() => {
        document.body.style.overflow = 'auto';
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    return (
        <div className="min-h-screen bg-[#FAFAFA] dark:bg-[#0a0a0f] text-slate-900 dark:text-white flex flex-col">
            <title>{title} | NoteSpace</title>
            <meta name="description" content={description} />
            <meta name="robots" content="index, follow" />

            <LandingNavbar onGetStarted={onGetStarted} />

            <main className="flex-1 pt-24">
                {children}
            </main>

            <LandingFooter />
        </div>
    );
};
